module.exports = __webpack_public_path__ + "img/兰州大学-300x300.821c3e09.jpg";